import {
    FETCH_PICKING_LIST_REQUEST,
    FETCH_PICKING_LIST_SUCCESS,
    FETCH_PICKING_LIST_FAILURE
} from "../actions/pickingListApiActions";

const initialState = {
    loading: true,
    items: [],
    error: ''
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PICKING_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PICKING_LIST_SUCCESS:
            return {
                loading: false,
                items: action.payload,
                error: ''
            };

        case FETCH_PICKING_LIST_FAILURE:
            return {
                loading: false,
                items: [],
                error: action.payload
            };
        default:
            return state;
    }
};

export default reducer;